const clientId = 'fefd078f319742b190c2cd34c1c37fd2';
const redirect_uri = "http://jamming.jeremykim.fr/";

let accessToken;

let Spotify = {
  getAccessToken(){
    if(accessToken) {
      return accessToken;
    }
    else if(window.location.href.match(/access_token=([^&]*)/) && window.location.href.match(/expires_in=([^&]*)/)) {
      accessToken = window.location.href.match(/access_token=([^&]*)/)[1];
      let expirationTime = window.location.href.match(/expires_in=([^&]*)/)[1];
      window.setTimeout(() => accessToken = '', expirationTime * 1000);
      window.history.pushState('Access Token', null, '/');
    }
    else {
      window.location = `https://accounts.spotify.com/authorize?client_id=${clientId}&response_type=token&scope=playlist-modify-public&redirect_uri=${redirect_uri}`;
    }
  },
  search(term) {
    Spotify.getAccessToken();
      return fetch(`https://cors-anywhere.herokuapp.com/https://api.spotify.com/v1/search?type=track&q=${term}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(response => response.json())
      .then(jsonResponse => {
        return jsonResponse.tracks.items.map(track => {
          return {
            id: track.id,
            name: track.name,
            artist: track.artists[0].name,
            album: track.album.name,
            uri: track.uri
          }
        });
      });

  },
  savePlaylist(playlistName, playlistTracks) {
    if(playlistName && playlistTracks) {
      Spotify.getAccessToken();
      let accessTokenVar = accessToken;
      let headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessTokenVar}`
      };
      let body = JSON.stringify({
        'name': playlistName
      });
      let userId;
      let playlistId;
      fetch(`https://cors-anywhere.herokuapp.com/https://api.spotify.com/v1/me`,
      {
        headers: headers
      })
      .then(response => response.json())
      .then(jsonResponse => {
        userId = jsonResponse.id;
      })
      .then(() => {
        fetch(`https://cors-anywhere.herokuapp.com/https://api.spotify.com/v1/users/${userId}/playlists`,
      {
        method: 'POST',
        headers: headers,
        body: body
      })
      .then(response => {
        return response.json();
        })
      .then(jsonResponse => {
        playlistId = jsonResponse.id;
      })
      .then(() => {
        fetch(`https://cors-anywhere.herokuapp.com/https://api.spotify.com/v1/users/${userId}/playlists/${playlistId}/tracks`,
        {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({
            'uris': playlistTracks
          })
        })
        .then(response => response.json())
        .then(jsonResponse => {
          playlistId = jsonResponse.id;
        })
      })});
    }
  }
};

export default Spotify;



// WEBPACK FOOTER //
// ./src/util/Spotify.js